export const SITE = {
  name: "Aiden Threadgoode",
  role: "Senior Software Engineer",
  email: "a.threadless@proton.me",
  phone: "207-749-1341",
  phoneHref: "tel:2077491341",
  github: "https://github.com/a-thread",
  githubHandle: "github.com/a-thread",
  linkedin: "https://www.linkedin.com/in/a-thread",
  linkedinHandle: "linkedin.com/in/a-thread",
  resumeDownloadUrl:
    "https://docs.google.com/document/d/1sA68wHHfIcCFOtg2DxkTUiGCc7eReWvk16JM7kYO8r0/export?format=pdf",
  resumeEmbedUrl:
    "https://docs.google.com/document/d/e/2PACX-1vRIQQCPL2xGJ_e0dKuza_VkhwG38bnqJKSQ8q6j-3X2Z491wZPrUlfXyMpmVQNVRatIxdB4h41zVhga/pub?embedded=true",
} as const;

export const emailHref = `mailto:${SITE.email}`;
